<template>
    <div class="slider" @touchstart.stop="jumpTo" @mousedown.left="jumpTo" @resize="recalcSize">
        <span class="thumb" 
            @mousedown.left.stop="thumb_drag = true" 
            @touchstart.stop="thumb_drag = true"></span>
        <span class="track-fill" @touchstart.stop="jumpTo" @mousedown.left.stop="jumpTo"></span>
    </div>
</template>
<script>
export default {
    name: 'slider',
    props: ['value', 'steps'],
    data () {
        return {
            thumb_drag: false,
            spots: [],
            thumbEl: null,
            trackEl: null,
            offset: 0,
            last_spot: 0,
        }
    },
    computed: {
    },
    methods: {
        getClosest (x) {
            let diffs = this.spots.map((spot) => Math.abs(x - spot))
            let min = diffs.indexOf(Math.min.apply(null, diffs))
            return this.spots[min]
        },
        jumpTo (event) {
            let x;
            if (event.type == 'touchstart') {
                x = event.touches[0].clientX
                event.preventDefault()
            }
            else {
                x = event.clientX
            }

            let spot = this.getClosest(x - this.offset)
            this.thumbEl.style.left = (spot - 12) + 'px'
            this.trackEl.style.width = spot + 'px'

            this.$emit('input', this.spots.indexOf(spot))
        },
        thumbCtrl (event) {
            if (!this.thumb_drag) return;

            let x;
            if (event.type == 'touchmove') {
                x = event.touches[0].clientX
                event.preventDefault()
            }
            else {
                x = event.clientX
            }

            let spot = this.getClosest(x - this.offset)
            this.thumbEl.style.left = (spot - 12) + 'px'
            this.trackEl.style.width = spot + 'px'

            if (spot != this.last_spot) {
                this.$emit('input', this.spots.indexOf(spot))
                this.last_spot = spot
            }
        },
        recalcSize () {
            this.thumbEl = this.$el.querySelector('.thumb')
            this.trackEl = this.$el.querySelector('.track-fill')
            let trigger = this.$el.clientWidth / this.steps

            this.offset = this.$el.offsetLeft

            for (let i=0; i <= this.steps; i++) {
                this.spots.push(i * trigger);
            }

            if (this.value) {
                this.thumbEl.style.left = (this.spots[this.value] - 12) + 'px'
                this.trackEl.style.width = this.spots[this.value] + 'px'
            }
        },
    },
    created () {
        document.addEventListener('mouseup', (event) => {
            this.thumb_drag = false
        });
        document.addEventListener('touchend', (event) => {
            this.thumb_drag = false
        });

        document.addEventListener('mousemove', this.thumbCtrl)
        document.addEventListener('touchmove', this.thumbCtrl, {passive: false})
    },
    mounted () {
        this.recalcSize()
    },
}
</script>
<style lang="scss">
$thumb: black;
$track-fill: black;
$light-border: #DFDFDF;

$track-height: 4px;
$thumb-size: 24px;

.slider {
    user-select: none;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    // border: solid 1px $light-border;
    height: $track-height;
    border-radius: $track-height;
    background: white;
}
.thumb {
    box-sizing: border-box;
    position: absolute;
    width: $thumb-size;
    height: $thumb-size;
    border-radius: $thumb-size;
    background: $thumb;
    background-size: cover;
    top: -(($thumb-size - $track-height)/2);
    left: -($thumb-size / 2);
    z-index: 3;
}
.track-fill {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    height: $track-height;
    border-radius: $track-height;
    width: 0;

    background: $track-fill;
    z-index: 1;
}

</style>
